module.exports = __webpack_public_path__ + "static/media/rs-ig.fee19711.svg";